import React from "react";
import styled from "styled-components";
import Hyperlink from "@components/common/hyperlink";
import { CommonProps } from "@utils/interface";
import { Flex } from "@acko-tech/building-blocks.ui.common";
import DOMPurify from "isomorphic-dompurify";
import { useSelector } from "react-redux";
import FastagIcon from "@public/images/fastagRecharge.svg";
import { currentYear } from "@utils/index";
interface StyledProps {
  styles?: {
    background?: string;
    color?: string;
    border?: string;
  };
}

const NudgeWrapper = styled.div<StyledProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  width: 100%;
  margin-top: 8px;
  border-radius: 8px;
  ${(props) => props.styles?.border && `border: ${props.styles.border};`}
  background: ${(props) =>
    props.styles?.background ||
    "linear-gradient(90deg, #E5F6F4 0%, #F2F9FB 100%)"};
`;

const Image = styled.div<{ hasImage: boolean }>`
  justify-content: center;
  width: ${(props) => (props.hasImage ? "20px" : "0")};
  height: ${(props) => (props.hasImage ? "17px" : "0")};
  flex-shrink: 0;
  min-width: ${(props) => (props.hasImage ? "19.962px" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${(props) => (props.hasImage ? "6px" : "0")};
  margin-left: ${(props) => (props.hasImage ? "6px" : "0")};
  padding: ${(props) => (props.hasImage ? "3px 2.038px 3.968px 2px" : "0")};
`;

const InlineContent = styled.div<StyledProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 85%;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${(props) => props.styles?.color ?? "#137547"};

  span {
    margin-right: 4px;
  }
`;

export interface IFastag extends CommonProps {
  title?: string;
  showIcon?: any;
  styles?: StyledProps["styles"];
  selectedPlan?: string;
  showFastag?: boolean;
}

const FastagNudge = ({ ...props }: IFastag) => {
  const { title, showIcon, styles, actions, selectedPlan, showFastag } = props;
  const { fastag_modal_on_click } = actions || {};
  const fastagTitle = useSelector(
    (state: any) =>
      state?.configuration?.normalisedConfig?.plans_container?.props
        ?.fastagTitle
  );
  const currentNode = useSelector(
    (state: any) => state?.configuration?.config?.current_node
  );

  const showFastagState = useSelector(
    (state: any) =>
      state?.configuration?.normalisedConfig?.plans_container?.props?.showFastag
  );

  if (selectedPlan === "car_tp") return null;
  if (showFastagState === false && currentNode === "plan_selection_node")
    return null;
  if (showFastag === false && currentNode === "checkout_review_node")
    return null;
  return (
    <Flex>
      <NudgeWrapper styles={styles}>
        <Image hasImage={showIcon}>
          {showIcon && (
            <FastagIcon
              style={{ width: 20, height: 17, objectFit: "contain" }}
            />
          )}
        </Image>
        <InlineContent style={{ color: styles?.color }}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                display: "inline-block",
                whiteSpace: "nowrap",
                overflowWrap: "break-word", 
                maxWidth: "100%"
              }}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(fastagTitle ?? title ?? "")
              }}
            />
            <Hyperlink
              clickHandler={() => {
                fastag_modal_on_click?.forEach((eachFunc: any) =>
                  eachFunc.funCall(eachFunc.args || {})
                );
              }}
              type="UNDERLINE"
              is_visible={true}
              text="Know more"
              styles={{
                width: "max-content",
                color: styles?.color ?? "#137547",
                cursor: "pointer"
              }}
            />
          </div>
        </InlineContent>
      </NudgeWrapper>
    </Flex>
  );
};
export default FastagNudge;
